import { Accordion } from "components/DesignSystem/Accordion/Accordion";
import { ReactNode } from "react";

type CollapsibleCardProps = {
  title: ReactNode;
  icon?: ReactNode;
  tag?: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
};

export const CollapsibleCard = ({
  title,
  icon,
  tag,
  defaultOpen = true,
  children,
}: CollapsibleCardProps) => {
  return (
    <Accordion.Root
      type="single"
      collapsible
      defaultValue={defaultOpen ? "open" : undefined}
    >
      <Accordion.Item value="open">
        <div className="t-relative">
          <Accordion.Trigger>
            <span className="t-flex t-items-center t-gap-3">
              {icon && (
                <span className="t-flex t-items-center t-justify-center t-w-8 t-h-8 t-rounded-lg t-bg-neutral-0 t-text-text-30">
                  {icon}
                </span>
              )}
              <span className="t-text-subtext t-text-text-60">{title}</span>
            </span>
          </Accordion.Trigger>
          {tag && (
            <div className="t-absolute t-right-9 t-top-1/2 -t-translate-y-1/2">
              {tag}
            </div>
          )}
        </div>
        <Accordion.Content className="!t-p-0">{children}</Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  );
};
